import { compileAllPages, Page } from "../../shared/utils/http-utils";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { City, CreateOrUpdateCity } from "../../survey/models/City";
import { OsmNode, OsmWay } from "../models/OsmData";

export const CityApi = {
  get: async (id: string) => {
    return await jwtAuthAxios().get<City>(`/cities/${id}`);
  },

  pageOsmNodes: async (id: string, pageSize: number, pageNumber: number) => {
    return await jwtAuthAxios().get<Page<OsmNode>>(`/cities/${id}/osm-nodes`, {
      params: {
        "page[size]": pageSize,
        "page[number]": pageNumber,
      },
    });
  },

  getOsmNodes: async (craWayId: string, pageSize: number = 5000) =>
    await compileAllPages(
      async (pageNumber) =>
        await CityApi.pageOsmNodes(craWayId, pageSize, pageNumber),
    ),

  pageOsmWays: async (id: string, pageSize: number, pageNumber: number) => {
    return await jwtAuthAxios().get<Page<OsmWay>>(`/cities/${id}/osm-ways`, {
      params: {
        "page[size]": pageSize,
        "page[number]": pageNumber,
      },
    });
  },

  getOsmWays: async (craWayId: string, pageSize: number = 5000) =>
    await compileAllPages(
      async (pageNumber) =>
        await CityApi.pageOsmWays(craWayId, pageSize, pageNumber),
    ),

  search: async (name: string, country: string) => {
    const params = new URLSearchParams({
      name,
      country,
    });

    return await jwtAuthAxios().get<City[]>(
      `/cities/search?${params.toString()}`,
    );
  },

  create: async (body: CreateOrUpdateCity) => {
    return await jwtAuthAxios().post<City>(`/cities`, body);
  },
};
